import { render, staticRenderFns } from "./ComponentArchive.vue?vue&type=template&id=6b1555c8"
import script from "./ComponentArchive.vue?vue&type=script&lang=js"
export * from "./ComponentArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports